import { computed, inject, Injectable, signal } from '@angular/core';
import { AuthService } from '@auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  authService = inject(AuthService);
  private readonly MUNICIPALITY_STORAGE_KEY = 'currentMunicipalityId';
  private readonly currentMunicipalityId = signal<string | null>(
    this.getStoredMunicipalityId()
  );

  private readonly user = computed(() => this.authService.currentUser());

  public isKeyUser = computed(() => this.user()?.municipalities.find(m => m.id === this._municipalityId())?.is_key_user ?? null);
  public isConsulent = computed(() => this.user()?.municipalities.find(m => m.id === this._municipalityId())?.is_consulent ?? null);
  public isAdmin = computed(() => this.user()?.is_admin ?? null);

  _municipalityId = signal<string | null>(null);
  municipalityId = computed(() => this._municipalityId());

  getCurrentMunicipalityId() {
    return this.currentMunicipalityId();
  }

  setCurrentMunicipalityId(id: string | null) {
    if (id) {
      this._municipalityId.set(id);
      sessionStorage.setItem(this.MUNICIPALITY_STORAGE_KEY, id);
    } else {
      sessionStorage.removeItem(this.MUNICIPALITY_STORAGE_KEY);
    }
  }

  private getStoredMunicipalityId(): string | null {
    return sessionStorage.getItem(this.MUNICIPALITY_STORAGE_KEY);
  }
}
